/**
 * Die Farbe der Knöpfe — „Freigeben", „GPX importieren", „Senden".
 *
 * **Chatübergreifend, und das war der Wunsch.** Sie steht bei den allgemeinen
 * Einstellungen und nicht an einer Reise: eine Reise soll nicht anders
 * aussehen als die nächste.
 *
 * **Leer heißt „wie das Erscheinungsbild".** Derselbe Gedanke wie bei den
 * Blasenfarben (`blasenfarben.ts`), und aus demselben Grund: die dunkle
 * Darstellung hat einen eigenen, helleren Akzent. Eine einmal gesetzte helle
 * Farbe gälte sonst auch dort, und ein blasses Grün auf dunklem Grund wäre
 * eine Sackgasse. Deshalb wird die Variable nur gesetzt, wenn wirklich etwas
 * gewählt wurde — sonst wird sie **weggenommen**.
 */

import { schriftAuf } from './blasenfarben'

/**
 * Die drei Variablen zu einer gewählten Farbe — oder dreimal `null`.
 *
 * - `--accent` ist die Fläche.
 * - `--accent-text` ist die Schrift darauf, gerechnet und nicht geraten
 *   (`schriftAuf`): wer ein dunkles Blau wählt, bekäme sonst dunkle Schrift
 *   darauf und läse nichts.
 * - `--accent-soft` ist der blasse Grund hinter Hinweisen und aktiven
 *   Reitern. **Als `rgba` und nicht als aufgehellte Farbe**: durchsichtig
 *   mischt sie sich mit dem Grund, auf dem sie liegt, und passt damit hell
 *   wie dunkel. Eine zu Weiß hin aufgehellte Fassung wäre in der dunklen
 *   Darstellung ein heller Fleck.
 */
export function knopfVariablen(farbe: string): Record<string, string | null> {
  if (!/^#[0-9a-fA-F]{6}$/.test(farbe)) {
    return { '--accent': null, '--accent-text': null, '--accent-soft': null }
  }

  const zahl = Number.parseInt(farbe.slice(1), 16)
  const r = (zahl >> 16) & 255
  const g = (zahl >> 8) & 255
  const b = zahl & 255

  return {
    '--accent': farbe,
    '--accent-text': schriftAuf(farbe),
    '--accent-soft': `rgba(${r}, ${g}, ${b}, 0.18)`,
  }
}
